import { resume } from "./mock";

import {
  cpfFormatter,
  cnpjFormatter,
  cpfSpecialCharactersRemover,
} from "../utils";

import axios from "axios";

const ENV_URL = process.env.REACT_APP_API_URL;

// LOGIN

export const loginCnpj = async (user, password, cnpj) => {
  const URL = `https://www.clubecerto.com.br/ws/new_assocsearch.php?user=${user}&token=${password}&cnpj=${cnpj}`;
  var teste = {
    user,
    cnpj,
    password,
  };
  try {
    const clientData = await axios({
      method: "get",
      url: URL,
    });
    return clientData.data.response.data;
  } catch (error) {
    console.log(error);
  }
};
export const loginCpf = async (worker) => {
  const URL = `https://node.clubecerto.com.br/workers/login`;

  try {
    const clientData = await axios({
      method: "post",
      url: URL,
      data: {
        cpf: worker.cpf,
        password: worker.senha,
      },
    });
    console.log(clientData.data);
    return clientData.data;
  } catch (error) {
    console.log(error);
    return "Erro login";
  }
};

// RELATÓRIO DO PAINEL

export const fetchReport = async (user, password, id, cpf) => {
  const URL = `https://clubecerto.com.br/ws/api/dashboard_api.php?empresa=${id}${!!cpf ? `&cpf=${cpf}` : ""
    }`;

  console.log(URL);

  try {
    const { data: reportFetched } = await axios({
      method: "get",
      url: URL,
    });

    return reportFetched;
  } catch (error) {
    console.log(error);
  }
};

// QUANTIDADE DE UTILIZAÇÕES, ECONOMIA GERADA E CATEGORIAS MAIS UTILIZADAS
// ( AINDA NÃO IMPLEMENTADO )

export const fetchResume = async (cpf) => {
  const resumeFetched = await resume;
  return resumeFetched;
};

// ESTABELECIMENTOS

// ----- get estabelecimentos
export const fetchAllEstablishments = async (
  user,
  password,
  page,
  isOnlyInactive,
  isOnlyFavorites,
  category,
  firstLetter,
  name
) => {
  const URL = `https://www.clubecerto.com.br/ws/api/2/estabelecimentos_destaque.php?user=${user}&token=${password}&cidade=&${!!category ? `categoria=${category}` : "categoria"
    }&palavra=&estado&palavra=${name}&destaque&porpagina=30&pagina=${page}&carrousel=${isOnlyFavorites}${isOnlyInactive ? "&desabilitado=1" : "&desabilitado="
    }`;

  try {
    const establishmentsList = await axios({
      method: "get",
      url: URL,
    });

    if (!!establishmentsList.data.Estabelecimentos)
      return establishmentsList.data.Estabelecimentos;

    return [];
  } catch (error) {
    console.log(error);
  }
};

// ----- detalhes de um estabelecimento
export const fetchEstablishmentDetails = async (
  user,
  password,
  establishmentId
) => {
  const URL = `https://www.clubecerto.com.br/ws/api/2/estabelecimento_dados.php?user=${user}&token=${password}&estabelecimento=${establishmentId}`;

  try {
    const establishmentDetails = await axios({
      method: "get",
      url: URL,
    });
    return establishmentDetails.data.Estabelecimento[0];
  } catch (error) {
    console.log(error);
  }
};

// ----- destacar estabelecimento
export const favoriteEstablishment = async (user, password, id) => {
  const establishment = await fetchEstablishmentDetails(user, password, id);

  const URL = `https://www.clubecerto.com.br/ws/api/2/estabelecimento_dados_destaque.php?user=${user}&token=${password}&estabelecimento=${id}&carrousel=${establishment.Carrousel === "1" ? "0" : "1"
    }`;

  const updatedEstablishment = {
    ...establishment,
    Carrousel: establishment.Carrousel === "1" ? "0" : "1",
  };

  try {
    await axios({
      method: "get",
      url: URL,
    });

    return updatedEstablishment;
  } catch (error) {
    console.log(error);
  }
};

// ----- ativar/desativar estabelecimento ( AINDA NÃO IMPLEMENTADO )
export const activateOrInactivateEstablishment = async (id) => {
  const establishment = await fetchEstablishmentDetails(id);
  const updatedEstablishment = {
    ...establishment,
    Ativo: establishment.Ativo === "1" ? "0" : "1",
  };
  // ATUALIZAR O MEMBRO VIA POST/PUT
  return updatedEstablishment;
};

// ASSOCIADOS

// ----- get associados
export const fetchAllMembers = async ({
  page,
  isActive,
  cpf,
  name,
  address,
  addressNum,
  token,
  product,
  order,
  initialDate, // Data de cadastro inicial
  finalDate,   // Data de cadastro final
}) => {
  const URL = `${ENV_URL}/companyDashboard/associate?limit=20&page=${page || 0
    }${isActive ? "&active=true" : "&active=false"}${cpf ? "&cpf=" + cpfSpecialCharactersRemover(cpf) : ""
    }${name ? "&name=" + encodeURIComponent(name) : ""}${address ? "&address=" + encodeURIComponent(address) : ""
    }${addressNum ? "&addressNum=" + encodeURIComponent(addressNum) : ""}${product ? "&product=" + encodeURIComponent(product) : ""
    }${order ? "&order=" + encodeURIComponent(order) : ""}${initialDate ? "&initialDate=" + encodeURIComponent(initialDate) : ""
    }${finalDate ? "&finalDate=" + encodeURIComponent(finalDate) : ""}`;

  const { data } = await axios.get(URL, { headers: { authorization: token } });

  return data;
};

// ----- ativar/desativar associado
export const activateOrInactivateMember = async (
  user,
  password,
  cnpj,
  idClient,
  cpf,
  isActive
) => {
  const { members } = await fetchAllMembers(
    user,
    password,
    cnpj,
    "1",
    isActive,
    cpf
  );

  const URL = `https://www.clubecerto.com.br/ws/new_edit.php?user=${user}&token=${password}&id=${members[0].id
    }&assoc=${idClient}&active=${members[0].ativo === "Ativo" ? "0" : "1"}`;

  console.log(URL);

  try {
    await axios({
      method: "get",
      url: URL,
    });

    return;
  } catch (error) {
    console.log(error);
  }
};

// ----- cadastrar associado
export const setNewMember = async ({ member, token }) => {
  const URL = `${ENV_URL}/companyDashboard/associate?origem=dashboard`;
  try {
    const response = await axios({
      method: "POST",
      url: URL,
      data: member,
      headers: {
        authorization: token || "",
      },
    });

    return response.data;
  } catch (error) {
    console.log(error.response);
    throw error.response.data;
  }
};

// TRANSAÇÕES

export const fetchTransactionsHistory = async (
  user,
  password,
  cpf,
  initialDate,
  finalDate
) => {
  const URL = `https://clubecerto.com.br/ws/api/2/ccanalise_destaque.php?user=${user}&token=${password}&cpf=${cpf}&dataInicial=${initialDate}&dataFinal=${finalDate}`;

  try {
    const history = await axios({
      method: "get",
      url: URL,
    });

    return history.data.Usuario[0].Acessos;
  } catch (error) {
    console.log(error);
  }
};

// CATEGORIAS

export const fetchCategories = async (user, password) => {
  const URL = `https://www.clubecerto.com.br/ws/api/2/categorias.php?user=${user}&token=${password}`;

  try {
    const categories = await axios({
      method: "get",
      url: URL,
    });

    return categories.data.Categorias;
  } catch (error) {
    console.log(error);
  }
};

// GET LISTA DE ESTADOS

export const fetchAllStates = async (user, password) => {
  const URL = `https://www.clubecerto.com.br/ws/api/2/estados.php?user=${user}&token=${password}`;

  try {
    const states = await axios({
      method: "get",
      url: URL,
    });

    return states.data.Estados;
  } catch (error) {
    console.log(error);
  }
};

// GET LISTA DE CIDADES

export const fetchCitiesByStateId = async (user, password, stateId) => {
  const URL = `https://www.clubecerto.com.br/ws/api/2/cidades.php?user=${user}&token=${password}&estado=${stateId}`;

  try {
    const cities = await axios({
      method: "get",
      url: URL,
    });

    return cities.data.Cidades;
  } catch (error) {
    console.log(error);
  }
};

//ADD FUNCIONÁRIO
export const newWorker = async ({ token, user, password, body }) => {
  const URL = "https://node.clubecerto.com.br/workers/add-worker";
  try {
    const postData = await axios({
      method: "post",
      url: URL,

      data: {
        user,
        password,
        worker: body,
      },
      headers: {
        Authorization: token || "",
      },
    });
    if (postData.data.success) {
      return true;
    } else {
      console.log('Erro ao cadastrar 1: ', postData.data.success);
      return false;
    }
  } catch (error) {
    console.log('Erro ao cadastrar 2: ', error);
    return error.response.data;
  }
};
//PAGINAÇÂO E GET GERAL DOS FUNCIONÁRIOS
export const getWorkers = async ({ token, user, password, id, pagination }) => {
  const URL = "https://node.clubecerto.com.br/workers";
  try {
    const cities = await axios({
      method: "post",
      url: URL,
      data: {
        user,
        password,
        id_empresa: id,
        pagination: pagination,
        porPage: 30,
      },
      headers: { Authorization: token || "" },
    });

    if (cities.success === false) {
      return "Error";
    }
    return cities.data.workers;
  } catch (error) {
    console.log(error);
    return "Error";
  }
};
//DELETAR FUNCIONÁRIO
export const deleteWorkers = async ({ token, user, password, id }) => {
  const URL = `https://node.clubecerto.com.br/workers/delete-worker`;
  console.log({ token, user, password, id });
  const deleteWorker = await axios.post(
    URL,
    {
      user,
      password,
      id: Number(id),
    },
    { Authorization: token || "" }
  );
  if (deleteWorker.data.success) {
    return true;
  } else {
    return false;
  }
};
//EDITA UM FUNCIONÁRIO
export const editWorker = async ({ token, user, password, worker }) => {
  const URL = "https://node.clubecerto.com.br/workers/edit-worker";
  try {
    const { data } = await axios({
      method: "post",
      url: URL,
      data: {
        user,
        password,
        worker: {
          id: worker.id,
          cpf: worker.cpf,
          name: worker.nome,
          password: worker.senha,
          admin: worker.admin,
        },
      },
      headers: { Authorization: token || "" },
    });
    if (data.success) {
      return true;
    } else {
      return false;
    }
  } catch {
    return false;
  }
};

//PEGA O NUMERO DE ASSOCIADOS INATIVOS E ATIVOS
export const activeInativeMembers = async ({
  page,
  isActive,
  cpf,
  name,
  address,
  addressNum,
  token,
  product,
  initialDate, // Data de cadastro inicial
  finalDate,   // Data de cadastro final
}) => {
  const URL = `${ENV_URL}/companyDashboard/associate/count?${isActive ? "&active=true" : "&active=false"}${cpf ? "&cpf=" + cpfSpecialCharactersRemover(cpf) : ""
    }${name ? "&name=" + encodeURIComponent(name) : ""}${address ? "&address=" + encodeURIComponent(address) : ""
    }${addressNum ? "&addressNum=" + encodeURIComponent(addressNum) : ""}${product ? "&product=" + encodeURIComponent(product) : ""
    }${initialDate ? "&initialDate=" + encodeURIComponent(initialDate) : ""
    }${finalDate ? "&finalDate=" + encodeURIComponent(finalDate) : ""}`;

  const { data } = await axios.get(URL, { headers: { authorization: token } });

  return data;
};

// export const activeInativeMembers = async (token) => {
//   const URL = `${ENV_URL}/companyDashboard/associate/count`;
//   const members = await axios.get(URL, {
//     headers: { authorization: token || "" },
//   });

//   if (!!members) {
//     return members.data;
//   } else {
//     return "error";
//   }
// };

//PEGA TODAS CATEGORIAS
export const getCategories = async (cod, pagination) => {
  const URL = "https://node.clubecerto.com.br/categories";
  try {
    const cities = await axios({
      method: "post",
      url: URL,
      data: {
        cod: cod,
        pagination: pagination,
        porPage: 30,
      },
    });
    if (cities.length === 0) {
      console.log("Bacana");
      return "Error";
    }
    return cities;
  } catch (error) {
    console.log(error);
    return "Error";
  }
};
//EDITA A CATEGORIA
export const editCategorie = async (cod, nome, id) => {
  const URL = "https://node.clubecerto.com.br/edit-categories";
  try {
    const cities = await axios({
      method: "post",
      url: URL,
      data: {
        cod: cod,
        name: nome,
        id: id,
      },
    });
    return "Tudo ok";
  } catch {
    console.log("tudo Errado Aqui");
  }
};
//EXCLUI UMA CATEGORIA
export const deleteCategorie = async (id) => {
  try {
    const URL = `https://node.clubecerto.com.br/delete-categories/${id}`;
    await axios.delete(URL);
    return "Usuario Deletado";
  } catch {
    console.log("tudo Errado Aqui");
  }
};
//ADICIONA UMA CATEGORIA
export const addCategorie = async (name, id) => {
  const URL = "https://node.clubecerto.com.br/add-categorie";
  try {
    const cities = await axios({
      method: "post",
      url: URL,
      data: {
        name: name,
        id: id,
      },
    });
    if (cities.length === 0) {
      return "Error";
    }
    return cities;
  } catch (error) {
    console.log(error);
    return "Error";
  }
};
export const sendPush = async (text) => {
  const URL = `https://clubecerto.com.br/task/integration/push.php?title=${text}`;
  await axios.post(URL);

  return "tudo ok";
};
export const numberDash = async (cod) => {
  const URL = `https://node.clubecerto.com.br/number-dash/verify`;

  const number = await axios.post(URL, {
    user: "clubecerto",
    password: "clubecerto",
    cliente: cod,
  });

  if (number.data.ativo == "1") {
    return number.data;
  } else {
    return 0;
  }
};
export const getMovement = async () => {
  const URL = `https://node.clubecerto.com.br/imagens-movimentos/4`;
  const moviments = await axios.get(URL);

  if (!!moviments.data) {
    return moviments.data;
  } else {
    return [];
  }
};
export const getPanelData = async ({ token, user, password }) => {
  const URL = `https://node.clubecerto.com.br/saude/dashboard/painel`;
  const { data } = await axios.post(
    URL,
    { user, password },
    {
      headers: {
        Authorization: token || "",
      },
    }
  );
  return data;
};
export const fetchDeprecatedAllMembers = async (
  user,
  password,
  cpnj,
  page,
  isActive,
  cpf
) => {
  const URL = `https://www.clubecerto.com.br/ws/search_destaque.php?user=${user}&token=${password}&id=&name&${!!cpf && cpf.length === 11
    ? `cpf=${cpfFormatter(cpf)}`
    : cpf.length === 14
      ? `cpf=${cnpjFormatter(cpf)}`
      : "cpf"
    }&assoc=${cpnj}&statusCard=&data&active=${isActive}&porpagina=30&pagina=${page}`;

  console.log(URL);

  return fetch(URL)
    .then((response) => response.text())
    .then((data) => {
      const parser = new DOMParser();
      const xmlDOM = parser.parseFromString(data, "text/xml");
      const values = xmlDOM.getElementsByTagName("response")[0].childNodes;
      const valuesArray = [...values];
      const infoArray = valuesArray
        .filter((info) => info.childNodes.length !== 0)
        .map((info) => info.childNodes[0].data);

      if (infoArray[0] === "Nenhum resultado encontrado.")
        return { error: "Nenhum resultado encontrado." };

      const members = [];
      let newMemberInfo = [];
      for (let index = 0; index < infoArray.length; index += 1) {
        newMemberInfo.push(infoArray[index]);
        if ((index + 1) % 5 === 0 && index !== 0) {
          const newMember = {
            id: newMemberInfo[0],
            nome: newMemberInfo[1],
            cpf: newMemberInfo[2],
            status_cartao: newMemberInfo[3],
            ativo: newMemberInfo[4],
          };
          members.push(newMember);
          newMemberInfo = [];
        }
      }
      return { members };
    })
    .catch((error) => console.log(error));
};

export const inativeAssociated = async ({ cpf, token }) => {
  const URL = `${ENV_URL}/companyDashboard/associate/${cpfSpecialCharactersRemover(
    cpf
  )}?origem=dashboard`;
  try {
    const response = await axios({
      method: "DELETE",
      url: URL,
      headers: {
        authorization: token || "",
      },
    });

    return response.data;
  } catch (error) {
    console.log(error.response);
    throw error.response.data;
  }
};

export const getTelemedicineLink = async ({ cpf, token }) => {
  const URL = `${ENV_URL}/companyDashboard/appointment/${cpf}?force=true`;
  try {
    const response = await axios({
      method: "GET",
      url: URL,
      headers: {
        authorization: token || "",
      },
    });

    return response.data;
  } catch (error) {
    console.log(error.response);
    throw error.response.data;
  }
  
};
